"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
const parse_1 = require("./cst/parse");
const env_1 = require("./std/env");
const _law_1 = __importDefault(require("./std/rules/$law"));
const virtualLine_1 = require("./std/virtualLine");
const parse = (lawtext) => {
    const lines = (0, parse_1.parse)(lawtext);
    const vls = (0, virtualLine_1.toVirtualLines)(lines.value);
    const env = (0, env_1.initialEnv)({ target: lawtext });
    const law = _law_1.default.match(0, vls, env);
    if (law.ok) {
        return {
            value: law.value.value,
            virtualLines: vls,
            errors: [...lines.errors, ...law.value.errors],
        };
    }
    else {
        throw new Error(`parse failed: offset ${law.offset}; expected ${law.expected}`);
    }
};
exports.parse = parse;
//# sourceMappingURL=lawtext.js.map